
import React, { useState } from "react";
import { CiSquarePlus } from "react-icons/ci";
import "react-phone-input-2/lib/style.css";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";


const SubjectWP = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
 

 
  return (
    <>
      <div className="flex items-center xl:p-5 sm:p-0 justify-center">
        <div className="w-full border rounded-3xl shadow-xl p-5 px-10">
          <div className="mt-3  flex  items-center">
            <div>
              {" "}
              <p className="text-2xl font-semibold ">{t("teacherDash.common.settings")}</p>
            </div>
          </div>

          {/* tableee----------- */}
          <div className="flex  flex-wrap md:justify-start justify-center  space-x-5  border-b-2 text-base font-medium my-5">
            <NavLink
              to=".././profile-setting-tech"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-500 border-b-2 border-blue-500"
                  : undefined
              }
            >
              {t("teacherDash.settingTabs.profileSettings")}
            </NavLink>

            <NavLink
              to=".././specialization-tech"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-500 border-b-2 border-blue-500"
                  : undefined
              }
            >
              {t("teacherDash.saveDetail.subjectsWp")}
            </NavLink>

            <NavLink
              to=".././other-detail"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-500 border-b-2 border-blue-500"
                  : undefined
              }
            >
              {t("teacherDash.settingTabs.otherDetails")}
            </NavLink>

            <NavLink
              to=".././security"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-500 border-b-2 border-blue-500"
                  : undefined
              }
            >
              {t("teacherDash.settingTabs.privacySecurity")}
            </NavLink>

            {/* <NavLink
              to=".././teacher-noti-setting"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-500 border-b-2 border-blue-500"
                  : undefined
              }
            >
              Notification
            </NavLink> */}
          </div>
          {/* end---------- */}

          <div className="md:flex  flex-wrap justify-between">
            <div className="mt-5">
              <p className="text-[22px] font-semibold ">
                {t("teacherDash.subjectWp.heading")}
              </p>
            </div>
            <div className="flex space-x-5 mt-5 cursor-pointer ">
              <p className="text-[11px] text-[#B5B7C0] border border-[#B5B7C0] px-6 py-2  rounded-lg">
                {t("teacherDash.common.cancel")}
              </p>
              <p className="text-[11px]  text-[#5963F5] border border-[#5963F5] px-6 py-2 rounded-lg">
                {t("teacherDash.common.save")}
              </p>
            </div>
          </div>

          <div className="md:w-1/2 w-full">
            <div className="mt-5">
              <p className="text-xl font-semibold ">{t("teacherDash.subjectWp.mainOtherSubjects")}</p>
              <p className="text-lg font-semibold mt-5 ">{t("teacherDash.subjectWp.mainSubject")}</p>
            </div>
            <form action="">
              <div className="md:flex block md:space-y-0 space-y-3 mt-5 gap-10 w-1/2">
                <div className="flex-1 bg-[#F9FBFF] border border-[#F9FBFF] rounded-lg px-1 ">
                  <select
                    className="outline-none px-1 py-2 focus-none  w-full bg-[#F9FBFF] cursor-pointer"
                    placeholder="Country"
                    type="text"
                  >
                    <option value="">{t("teacherDash.subjectWp.selectSubjectOption")}</option>
                    <option>{t("teacherDash.subjectWp.subjectMath")}</option>
                    <option>{t("teacherDash.subjectWp.subjectEnglish")}</option>
                    <option>{t("teacherDash.subjectWp.subjectChemistry")}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>

          <div className="md:w-1/2 w-full">
            <p className="text-lg font-semibold mt-5 ">
              {t("teacherDash.subjectWp.willingToTeachMain")}
            </p>
            <div className="flex justify-between mt-4 mx-3">
              <div className="flex items-center">
                <input
                  id="radio1"
                  type="radio"
                  name="radio-group"
                  value="online"
                  checked={selectedOption === "online"}
                  onChange={() => setSelectedOption("online")}
                  className="form-radio h-4 w-4 text-blue-600"
                />
                <label
                  for="radio1"
                  className="ml-2 text-gray-700 text-base font-medium"
                >
                  {t("teacherDash.subjectWp.onlineOption")}
                </label>
              </div>
              <div className="flex items-center">
                <input
                  id="radio2"
                  type="radio"
                  name="radio-group"
                  value="home"
                  checked={selectedOption === "home"}
                  onChange={() => setSelectedOption("home")}
                  className="form-radio h-4 w-4 text-blue-600"
                />
                <label
                  for="radio2"
                  className="ml-2 text-gray-700 text-base font-medium"
                >
                  {t("teacherDash.subjectWp.atHomeOption")}
                </label>
              </div>
              <div className="flex items-center">
                <input
                  id="radio3"
                  type="radio"
                  name="radio-group"
                  value="both"
                  checked={selectedOption === "both"}
                  onChange={() => setSelectedOption("both")}
                  className="form-radio h-4 w-4 text-blue-600"
                />
                <label
                  for="radio3"
                  className="ml-2 text-gray-700 text-base font-medium"
                >
                  {t("teacherDash.subjectWp.bothOption")}
                </label>
              </div>
            </div>
            {selectedOption === "online" && (
              <div>
                <p className="text-lg mt-2 font-medium">
                  {t("teacherDash.subjectWp.chargesRangeOnline")}
                </p>
                <input
                  type="text"
                  name=""
                  id="onlineRange"
                  className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                  placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                />
              </div>
            )}

            {selectedOption === "home" && (
              <div>
                <p className="text-lg mt-2 font-medium">
                  {t("teacherDash.subjectWp.chargesRangeHome")}
                </p>
                <input
                  type="text"
                  name=""
                  id="homeRange"
                  className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                  placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                />
              </div>
            )}

            {selectedOption === "both" && (
              <>
                <div>
                  <p className="text-lg mt-2 font-medium">
                    {t("teacherDash.subjectWp.chargesRangeOnline")}
                  </p>
                  <input
                    type="text"
                    name=""
                    id="onlineRange"
                    className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                    placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                  />
                </div>
                <div>
                  <p className="text-lg mt-2 font-medium">
                    {t("teacherDash.subjectWp.chargesRangeHome")}
                  </p>
                  <input
                    type="text"
                    name=""
                    id="homeRange"
                    className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                    placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                  />
                </div>
              </>
            )}
          </div>

          <div className="md:w-1/2 my-8 w-full  flex justify-between items-center ">
            <div>
              {" "}
              <p className="text-lg font-semibold ">{t("teacherDash.subjectWp.otherSubjects")}</p>
            </div>

            <div className="flex space-x-5" onClick={() => setShowModal(true)}>
              <CiSquarePlus className=" text-[25px] text-[#5963F5] cursor-pointer" />
            </div>
          </div>
        </div>
      </div>

      {/* modal */}
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative mx-auto md:w-2/5">
              {/* {/content/} */}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none overflow-y-auto shiftmodel p-5 ">
                {/* {/header/} */}
                <div className="flex items-start justify-center  border-solid border-blueGray-200 rounded-t">
                  <button
                    className=" ml-auto  float-right text-2xl"
                    onClick={() => setShowModal(false)}
                  >
                    <span> × </span>
                  </button>
                </div>

                <div className="flex justify-center">
                  <h1 className="text-2xl font-medium">{t("teacherDash.addSubject.editSubjectTitle")}</h1>
                </div>

                <div className="lg:w-2/3 w-full m-auto">
                  <div>
                    <p className="text-lg mt-2 font-medium">{t("teacherDash.common.subject")}</p>
                  </div>
                  <div>
                    <select className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2">
                      <option value="">{t("teacherDash.addSubject.selectClassOption")}</option>
                      <option>{t("teacherDash.subjectWp.subjectMath")}</option>
                      <option>{t("teacherDash.subjectWp.subjectScience")}</option>
                      <option>{t("teacherDash.subjectWp.subjectHistory")}</option>
                    </select>
                  </div>
                  <div>
                    <p className="text-lg mt-2 font-medium">
                      {t("teacherDash.subjectWp.willingToTeachMain")}
                    </p>
                  </div>
                  <div className="flex justify-between mt-4 mx-3">
                    <div className="flex items-center">
                      <input
                        id="radio1"
                        type="radio"
                        name="radio-group"
                        value="online"
                        checked={selectedOption === "online"}
                        onChange={() => setSelectedOption("online")}
                        className="form-radio h-4 w-4 text-blue-600"
                      />
                      <label
                        for="radio1"
                        className="ml-2 text-gray-700 text-base font-medium"
                      >
                        {t("teacherDash.subjectWp.onlineOption")}
                      </label>
                    </div>
                    <div className="flex items-center">
                      <input
                        id="radio2"
                        type="radio"
                        name="radio-group"
                        value="home"
                        checked={selectedOption === "home"}
                        onChange={() => setSelectedOption("home")}
                        className="form-radio h-4 w-4 text-blue-600"
                      />
                      <label
                        for="radio2"
                        className="ml-2 text-gray-700 text-base font-medium"
                      >
                        {t("teacherDash.subjectWp.atHomeOption")}
                      </label>
                    </div>
                    <div className="flex items-center">
                      <input
                        id="radio3"
                        type="radio"
                        name="radio-group"
                        value="both"
                        checked={selectedOption === "both"}
                        onChange={() => setSelectedOption("both")}
                        className="form-radio h-4 w-4 text-blue-600"
                      />
                      <label
                        for="radio3"
                        className="ml-2 text-gray-700 text-base font-medium"
                      >
                        {t("teacherDash.subjectWp.bothOption")}
                      </label>
                    </div>
                  </div>
                  {selectedOption === "online" && (
                    <div>
                      <p className="text-lg mt-2 font-medium">
                        {t("teacherDash.subjectWp.chargesRangeOnline")}
                      </p>
                      <input
                        type="text"
                        name=""
                        id="OnlineRange"
                        className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                        placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                      />
                    </div>
                  )}

                  {selectedOption === "home" && (
                    <div>
                      <p className="text-lg mt-2 font-medium">
                        {t("teacherDash.subjectWp.chargesRangeHome")}
                      </p>
                      <input
                        type="text"
                        name=""
                        id="HomeRange"
                        className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                        placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                      />
                    </div>
                  )}

                  {selectedOption === "both" && (
                    <>
                      <div>
                        <p className="text-lg mt-2 font-medium">
                          {t("teacherDash.subjectWp.chargesRangeOnline")}
                        </p>
                        <input
                          type="text"
                          name=""
                          id="Online_range"
                          className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                          placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                        />
                      </div>
                      <div>
                        <p className="text-lg mt-2 font-medium">
                          {t("teacherDash.subjectWp.chargesRangeHome")}
                        </p>
                        <input
                          type="text"
                          name=""
                          id="Home_range"
                          className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
                          placeholder={t("teacherDash.subjectWp.perHoursPlaceholder")}
                        />
                      </div>
                    </>
                  )}
                  <NavLink to=".././add-subject">
                    <div className="flex justify-center my-5 mt-8 cursor-pointer">
                      <p className="bg-blue-500 w-fit hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg ml-2 focus:outline-none focus:shadow-outline">
                        {t("teacherDash.common.save")}
                      </p>
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
      {/* modal-end */}
    </>
  );
};

export default SubjectWP;
